import PropTypes from 'prop-types';
import { OpenInNew } from '@mui/icons-material';
import * as versionUtils from '../../utils/versionUtils';

const OpenResourceInNewWindowIcon = ({
    versionType = 'dataType',
    id,
    onNewWindowOpen,
    hideInsteadOfReturnNull,
    overrideUrl,
    overrideTitle,
    overrideIcon,
}) => {
    if (id || overrideUrl || hideInsteadOfReturnNull) {
        return (
            <div
                title={overrideTitle || 'View in new window'}
                onClick={async (e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    const openWindow = window.open(
                        overrideUrl ? overrideUrl : versionUtils.getUrlForVersionTypeById(versionType, 'refresh', id),
                        '_blank',
                    );

                    if (openWindow && typeof onNewWindowOpen === 'function') {
                        onNewWindowOpen();
                    }
                }}
                style={{
                    cursor: 'pointer',
                    marginLeft: '5px',
                    color: '#292929',
                    visibility: hideInsteadOfReturnNull && !id && !overrideUrl ? 'hidden' : 'visible',
                }}
            >
                {overrideIcon || <OpenInNew />}
            </div>
        );
    }

    return null;
};

OpenResourceInNewWindowIcon.propTypes = {
    versionType: PropTypes.string,
    id: PropTypes.string,
    onNewWindowOpen: PropTypes.func,
    hideInsteadOfReturnNull: PropTypes.bool,
    overrideUrl: PropTypes.string,
    overrideTitle: PropTypes.string,
    overrideIcon: PropTypes.any,
};

export default OpenResourceInNewWindowIcon;
